<template>
  <div>
    <router-view></router-view>
  </div>
  
</template>

<script>
export default {

}
</script>

<style type="scss">
html{
  font-family: 'Stalinist One', cursive;
}
body{
    margin: 0;
    padding: 0;
    background: #000;
    
}

</style>